import {IPoint} from "../interfaces/IPoint";

export class Point implements IPoint {

    public lat: number;
    public lon: number;
    public latitude: number;
    public longitude: number;
    public lng: any;

    constructor(lat: number, lon: number) {
        this.lat = lat;
        this.latitude = lat;
        this.lon = lon;
        this.lng = lon;
        this.longitude = lon;
    }

    public json(): IPoint {
        return {lat: this.lat, lon: this.lon};
    }

    public fromArray(arr: any): Point {
        return new Point(arr.lat, arr.lon);
    }

}
